// https://support.microsoft.com/en-us/office/learn-about-groups-in-outlook-b565caa1-5c40-40ef-9915-60fdb2d97fa2#id0ebbf=signinorgid
// https://support.microsoft.com/en-us/office/what-s-the-difference-between-a-microsoft-365-group-and-a-contact-list-in-outlook-ba7089fb-e464-41b2-88a8-5209499bd978

export const groups_info = 'Groups in Microsoft 365 are a combination of distribution lists and shared mailboxes, with the addition of collaborative tools to help your team achieve a common goal.'

export const groups_md = `
# Microsoft 365 Groups
*Last updated on July 14, 2025*

## Overview

Groups in Microsoft 365 are a combination of distribution lists and shared mailboxes, with the addition of collaborative tools to help your team achieve a common goal.
Creating a group automatically sets up a shared calendar and a shared Outlook inbox associated with the group's email address.
Additionally, all group members have access to a shared file repository and a dedicated Teams group.

## Benefits
- **Shared Inbox**: Much like a shared mailbox, members of a group have a shared inbox. However, you can subscribe to the group to have its messages appear in your personal inbox as well.
- **Shared Files Library**: Every group gets a SharePoint file library where members can store, share, and collaborate on documents, workbooks, presentations, images, and more.
- **Shared Calendar**: Group members also receive a shared calendar to add group-related events. Members may optionally choose to have events show up on their personal calendars as well.
- **Guest Access**: External guests can be added to the group to see email conversations and shared files.
- **Dedicated Teams Channel**: Upon the creation of a group, you can choose to grant it a dedicated Teams channel. Here, members can efficiently collaborate over Teams instead of in email chains.
- **Self-Service**: You can create a new group without any help or permission from the IT Help Desk!
- **Easily Discoverable**: Public groups can be easily joined through Outlook or Teams. Groups can be made private and people can request access if the topics it covers are sensitive.

## Requirements
- A user account with us
- A valid Microsoft 365 subscription
- An up to date version of Windows

## Getting Started
- See this [guide by Microsoft](https://support.microsoft.com/en-us/office/create-a-group-in-outlook-04d0c9cf-6864-423c-a380-4fa858f27102#id0ebf=new_outlook) or...
1. Open up Outlook
2. Go to the Groups tab
    - On the left side of your screen, under all your mail folders, click 'Go to Groups'
    - Alternatively, on the sidebar on the left of your screen click the Groups icon
    - If the Groups icon is not visible, you may need to click on the 'More apps' 4 squares icon and search for it there. We recommend right clicking on and pinning the Groups icon if you find it here.
3. On the top ribbon bar, select the dropdown arrow and click on 'New group.'
4. Configure the desired name, email address, description, and default settings. Click Create when you're finished.
5. You'll now be prompted to add members to your group. You can choose to do this now or later.
    - Private groups require you to manually members add or approve their join requests.
    - Public groups can be joined by anyone within the organization. External members will need to be invited. 


## Support
- Contact our [IT Help Desk](https://it.bockwaterheaters.com/#/help)

`